<template>
  <div class="backdrop-video">
    <!--
      1. x5-video-player-type 启用H5同层播放器
      2. x5-video-player-fullscreen全屏方式
        注： 声明此属性，需要页面自己重新适配新的视口大小变化。可以通过监听resize 事件来实现
    -->
    <basis-video-player
      v-if="item.video"
      v-model="videoPlayer"
      class="video-player"
      :item="item"
      :cover-options="{
        aspectRatio: '1:1',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      }"
      @playerReadied="onPlayerReadied"
    />
    <div
      v-if="!item.video"
      :class="['not-video', {'is-locked': item.locked}]"
      :style="{backgroundImage:`url(${item.cover})`}"
    />
  </div>
</template>

<script>
import { BasisVideoPlayer } from '@/components/basis'

export default {
  name: 'BackdropVideo',
  components: { BasisVideoPlayer },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    videoPlayer: undefined,
    mode: false
  }),
  watch: {
    '$route.params.id': {
      handler (newId, oldId) {
        if (newId !== oldId) {
          this.mode = false
          this.video && this.video.load()
        }
      }
    }
  },
  methods: {
    toggoleVideoHandler () {
      this.mode = !this.mode
      switch (this.mode) {
        case true:
          this.videoPlayer.player.play()
          break
        case false:
          this.videoPlayer.player.pause()
          break
      }
    },
    // player is ready
    onPlayerReadied (player) {
      // seek to 10s
      player.currentTime(10)
    }
  }
}
</script>

<style scoped lang="scss">
.backdrop-video {
  @include wh(100%, 100%);
  .not-video {
    margin: 20px 0 200px;
    @include bg-image-fit;
    width: 100%;
    height: 100vw;
    background-size: contain;
    &.is-locked {
      filter: blur(5px);
    }
  }
  .video-player {
    margin: 20px 0 0px;
  }
}
</style>
